export const SUSTAINABILITY_ANSERQUESTION = 'sustainability/answerQuestion';
export const SUSTAINABILITY_SAVE_ANSWERS = 'sustainability/saveAnswers';
export const SUSTAINABILITY_DELETE_FORMS = 'sustainability/deleteForms';
export const SUSTAINABILITY_UPDATE_DOCUMENT_FILENAME = 'sustainability/updateDocumentFilename';
export const CERTIFICATION_DELETE = 'certification/deleteCertification';
export const CERTIFICATION_UPDATE = 'certification/updateCertification';
